import { PartNoBg } from '../styledComponents'
import TruncateText from '$components/TruncateText'
import { getColorLabel } from '$utils/i18n'

const createColumnsSummary = (t) => {
  const columns = [
    {
      title: t('Part No'),
      dataIndex: ['part', 'id_part_client'],
      render: (title) => <PartNoBg>{title}</PartNoBg>,
      width: '160px',
    },
    {
      title: t('Part Name'),
      dataIndex: ['part', 'name'],
      render: (text) => <TruncateText text={text} />,
      ellipsis: true,
    },
    {
      title: t('Material'),
      render: (record) => {
        const materialName =
          record.additive_material_name || record.material_name || t('unknown')
        return (
          <TruncateText
            text={`${materialName}${getColorLabel(record.selected_color, t)}`}
          />
        )
      },
      ellipsis: true,
    },
    {
      title: t('Quantity'),
      dataIndex: 'amount',
    },
  ]

  return columns
}

export default createColumnsSummary
